import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShowComponent } from '../RoleBasedComponents';
import './GenericDropdown.css';

const GenericDropdown = ({ isExpanded, onClose, items, position }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleClick = (path) => {
    navigate(path);
    onClose();
  };

  if (!isExpanded) return null;

  return (
    <div 
      ref={dropdownRef}
      className="generic-dropdown"
      style={{
        left: position.left,
        top: position.top
      }}
    >
      {items.map((item) => (
        <ShowComponent key={item.path} permission={item.permission}>
          <div
            className="generic-dropdown-item"
            onClick={() => handleClick(item.path)}
          >
            {item.label}
          </div>
        </ShowComponent>
      ))}
    </div>
  );
};

export default GenericDropdown; 